// @ts-nocheck

import pxToRem from "assets/theme/functions/pxToRem";

const accordionSummary = {
  styleOverrides: {
    root: {
      minHeight: pxToRem(48),
      padding: `0 ${pxToRem(16)}`,
    },

    content: {
      margin: `${pxToRem(12)} 0`,
    },
  },
};

export default accordionSummary;
